import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $integrationsStore } from '@lib/store';
import { IntegrationList } from './widgets';
import { PageContainer } from '@shared/widgets';

export const IntegrationsPage = () => {
  const integrationsStore = useUnit($integrationsStore.store);

  const { t } = useTranslation('integrations');

  useEffect(() => {
    $integrationsStore.events.get();
  }, []);

  return (
    <PageContainer loading={integrationsStore.loading} title={t('title')} header={t('header')}>
      <IntegrationList list={integrationsStore.data} />
    </PageContainer>
  );
};
